export default "__VITE_ASSET__CKvwHMIB__"